/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * 배터리 상태 조회 응답
 */
export type GetEvBatteryManufacturerResponse = {
  /**
   * 배터리 제조사
   */
  batteryManufacturer: GetEvBatteryManufacturerResponse.batteryManufacturer;
};
export namespace GetEvBatteryManufacturerResponse {
  /**
   * 배터리 제조사
   */
  export enum batteryManufacturer {
    UNKNOWN = 'UNKNOWN',
    SK_ON = 'SK_ON',
    LG_ENERGY_SOLUTION = 'LG_ENERGY_SOLUTION',
    CATL = 'CATL',
  }
}

